import type { ComponentType } from 'react';

/**
 * The icon to the left of every command-palette row — pages, recents, and
 * quick actions all render through this one component so the list reads as
 * a single system instead of "quick actions have icons, pages don't" (the
 * gap the first version shipped with).
 *
 * Bare, no chip/background/border — the first version's 28px `bg-muted`
 * square read as noticeably bulkier and more "boxy" than anything else in
 * this app; the sidebar's own nav icons (`SidebarItem`, 17px, no
 * background) are the reference. Still a fixed-width span so every row's
 * label starts at the same x position regardless of glyph width.
 */
export function CommandRowIcon({ icon: Icon }: { icon: ComponentType<{ size?: number }> }) {
  return (
    <span className="flex w-[18px] shrink-0 items-center justify-center text-muted-foreground">
      <Icon size={16} />
    </span>
  );
}
